import { render } from "./ArticleDetailed.vue?vue&type=template&id=0552f9e4&scoped=true"
import script from "./ArticleDetailed.vue?vue&type=script&lang=js"
export * from "./ArticleDetailed.vue?vue&type=script&lang=js"

import "./ArticleDetailed.vue?vue&type=style&index=0&id=0552f9e4&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0552f9e4"]])

export default __exports__